import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getSystemPermissionsList } from '@/service/systemControl'

const initialState = {
  fetching: false,
  error: null,
  list: []
}

/**
 * 拉取权限列表。首个参数为 GET 查询对象，原样传给 getSystemPermissionsList；不传则等价于 `{}`。
 * @param {Record<string, unknown>} [query={}]
 */
export const fetchSystemPermissionsList = createAsyncThunk(
  'systemPermission/fetchList',
  async (query = {}, { rejectWithValue }) => {
    try {
      const res = await getSystemPermissionsList(query)
      const raw = res?.data
      if (raw == null) return []
      if (Array.isArray(raw)) return raw
      return [raw]
    } catch (error) {
      const msg =
        error?.message ||
        error?.response?.data?.msg ||
        '加载权限列表失败'
      return rejectWithValue(msg)
    }
  }
)

const systemPermissionSlice = createSlice({
  name: 'systemPermission',
  initialState,
  reducers: {
    resetSystemPermissionList: (state) => {
      state.list = []
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSystemPermissionsList.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchSystemPermissionsList.fulfilled, (state, action) => {
        state.fetching = false
        state.list = action.payload
        state.error = null
      })
      .addCase(fetchSystemPermissionsList.rejected, (state, action) => {
        state.fetching = false
        state.list = []
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export const { resetSystemPermissionList } = systemPermissionSlice.actions
export default systemPermissionSlice.reducer
